import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Management routes
const Users = Loader(
  lazy(() => import('src/content/admin-content/management/Users'))
);
const Roles = Loader(
  lazy(() => import('src/content/admin-content/management/Roles'))
);
const VendorList = Loader(
  lazy(() => import('src/content/admin-content/vendor-list'))
);
const VendorDetails = Loader(
  lazy(() => import('src/content/admin-content/vendor-details'))
);
const UserProfile = Loader(
  lazy(() => import('src/content/admin-content/management/Users/profile'))
);

// const VendorApproval = Loader(
//   lazy(() => import('src/content/admin-content/vendor-approval'))
// );

const managementRoutes = [
  {
    path: '',
    element: <Navigate to="users" replace />
  },
  {
    path: 'user-management',
    children: [
      {
        path: 'users',
        element: <Users />
      },
      {
        path: 'users/:userId',
        element: <UserProfile />
      },
      {
        path: 'roles',
        element: <Roles />
      }
    ]
  },
  {
    path: 'vendor-management',
    children: [
      {
        path: 'vendor-details/:vendorId',
        element: <VendorDetails />
      },
      {
        path: 'vendors',
        element: <VendorList />
      }
      // {
      //   path: 'vendor-approval',
      //   element: <VendorApproval />
      // }
    ]
  }
];

export default managementRoutes;
